import HomePage from './components/HomePage.vue'
import Korisnici from './components/Korisnici.vue'
import DavateljiUsluga from './components/DavateljiUsluga.vue'
import Dokumentacija from './components/Dokumentacija.vue'
import Kontakt from './components/Kontakt.vue'

export const routes = [
    { path: '', component: HomePage },
    { path: '/korisnici', component: Korisnici },
    { path: '/davatelji_usluga', component: DavateljiUsluga },
    { path: '/dokumentacija', component: Dokumentacija },
    { path: '/kontakt', component: Kontakt },
]